export default {
    setDataFeeds(state, value) {
        state.dataFeeds = value;
    },
    setDataFeedsLoading(state, value) {
        state.dataFeedsLoading = value;
    },
    addDataFeed(state, payload) {
        state.dataFeeds.push(payload);
    },
    deleteDataFeed(state, payload) {
        const idx = state.dataFeeds.findIndex((e) => {
            return e.id == payload.id;
        });
        if (idx != -1) {
            state.dataFeeds.splice(idx, 1);
        }
    },
    updateDataFeed(state, payload) {
        const idx = state.dataFeeds.findIndex((e) => e.id == payload.id);
        if (idx !== -1) {
            state.dataFeeds[idx] = {
                id: payload.id,
                feed_id: payload.feed_id,
                provider: payload.provider,
                provider_id: payload.provider_id,
                provider_reference: payload.provider_reference,
                status_id: payload.status_id,
                edit: false,
            };
        }
    },
};
